import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {UserAction} from "../actions/UserAction"
import {SearchAction} from "../actions/SearchAction"
import i18n from "i18next"
import {Modal, Table} from "antd";
import {getAsStr, izBlank, izEmpty, izNotBlank, izNotEmpty} from "../constants";

class ScoreCardModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false,
            columns: [
                {
                    title: i18n.t('scoreCardType'),
                    dataIndex: 'type',
                    key: 'type',
                    render: (type, record) => i18n.t('scoreCardType_' + type)
                },
                {
                    title: i18n.t('scoreCardSource'),
                    dataIndex: 'source',
                    key: 'source',
                    align: 'center',
                    render: (source, record) => this.source(source)
                },
                {
                    title: i18n.t('scoreParamKey'),
                    dataIndex: 'scoreParamKey',
                    key: 'scoreParamKey',
                    render: (type, item) => this.scoreParamKey(item)
                },
                {
                    title: i18n.t('scoreParamValue'),
                    dataIndex: 'scoreParamValue',
                    key: 'scoreParamValue',
                    render: (type, item) => this.scoreParamValue(item)
                },
                {
                    title: i18n.t('score'),
                    dataIndex: 'score',
                    key: 'score',
                    render: (score, record) => this.score(score)
                },
                // {
                //     title: i18n.t('updatedDate'),
                //     dataIndex: 'updatedDate',
                //     key: 'updatedDate',
                //     render: (updatedDate, item) => updatedDate
                // },
            ],
        }
    }

    source(source) {
        return <div className="score-card-source">{source}</div>
    }

    scoreParamValue(record) {
        const {sourceParams, source} = record;
        const {customer} = this.props
        let dataMap = customer;
        if (record.type === "TX") dataMap = this.getTxData(source);

        return this.getParamValue(sourceParams, dataMap);
    }

    scoreParamKey(record) {
        const {sourceParams, source} = record;
        const {customer} = this.props
        let dataMap = customer;
        if (record.type === "TX") dataMap = this.getTxData(source);

        return this.getParamKey(sourceParams, dataMap);
    }

    getTxData(source) {
        const {txItems} = this.props
        const filteredTx = txItems.filter(tx => tx.txId === source);
        return izEmpty(filteredTx) ? {} : filteredTx[0].txData;
    }

    score(score) {
        return {
            props: {
                style: {background: "#204f79"}
            },
            children: <div className="score-card-score">{score}</div>
        };
    }

    onCancel = () => {
        this.setState({modalVisible: false})
    }

    showScoreDetailModal() {
        this.setState({modalVisible: true})
    }

    getParamKey(sourceParams, dataMap) {

        const splitSourceParams = sourceParams.split("#P#");

        return splitSourceParams
            .filter(p => izNotBlank(p))
            .filter(p => p.includes(":::"))
            .map(function (sourceParam) {
                    const sourceParamDetails = sourceParam.split(":::");
                    if (izEmpty(sourceParamDetails)) return "";

                    const paramCode = sourceParamDetails[0];
                    if (izBlank(paramCode)) return "";
                    const paramName = sourceParamDetails[1];
                    if (izBlank(paramName)) return "";

                    let customerPropVal = dataMap[paramCode];

                    if (customerPropVal === undefined || customerPropVal === "") return ""

                    if (paramCode === "maritalStatus") {
                        const maritalStatus = getAsStr(customerPropVal);
                        const hideMaritalStatus = izBlank(maritalStatus) || (maritalStatus !== "1" && maritalStatus !== "2");

                        customerPropVal = hideMaritalStatus ? "" : i18n.t('maritalStatus_' + maritalStatus);

                        if (izBlank(customerPropVal)) return "";
                    }

                    return paramName;
                }
            )
            .filter(pd => izNotBlank(pd))
            .join(" / ");
    }

    getParamValue(sourceParams, dataMap) {

        const splitSourceParams = sourceParams.split("#P#");

        return splitSourceParams
            .filter(p => izNotBlank(p))
            .filter(p => p.includes(":::"))
            .map(function (sourceParam) {
                    const sourceParamDetails = sourceParam.split(":::");
                    if (izEmpty(sourceParamDetails)) return "";

                    const paramCode = sourceParamDetails[0];
                    if (izBlank(paramCode)) return "";
                    const paramName = sourceParamDetails[1];
                    if (izBlank(paramName)) return "";
                    const paramDataType = sourceParamDetails[2];

                    let customerPropVal = dataMap[paramCode];
                    if (customerPropVal === undefined || customerPropVal === "") return ""

                    if (paramCode === "maritalStatus") {
                        const maritalStatus = getAsStr(customerPropVal);
                        const hideMaritalStatus = izBlank(maritalStatus) || (maritalStatus !== "1" && maritalStatus !== "2");

                        customerPropVal = hideMaritalStatus ? "" : i18n.t('maritalStatus_' + maritalStatus);

                        if (izBlank(customerPropVal)) return "";
                    } else if (izNotBlank(paramDataType) && paramDataType.toLowerCase() === "boolean") {
                        customerPropVal = customerPropVal === true ? i18n.t('yes') : i18n.t('no')
                    }

                    return customerPropVal;
                }
            )
            .filter(pd => izNotBlank(pd))
            .join(" / ");
    }

    render() {

        const {modalVisible, columns} = this.state

        const {customer, scores, riskLevelTag} = this.props
        if (izEmpty(scores)) return "";

        const customerFinalScore = customer.score;

        const ruleEngineScores = scores.filter(s => s.type === "RE");
        const txScores = scores.filter(s => s.type === "TX");

        let txTotalScores = 0;
        if (izNotEmpty(txScores)) txScores.forEach(ts => txTotalScores += ts.score);

        return (
            <>
                <a className="customer-risk-level-cortingen"
                   onClick={(e) => {
                       this.showScoreDetailModal(e)
                   }}
                   href="#">
                    {riskLevelTag}
                </a>

                <Modal
                    title={
                        <div className="score-title">
                            Müşteri Skor Detay
                        </div>
                    }
                    className="score-detail-modal"
                    visible={modalVisible}
                    onCancel={this.onCancel}
                    width={"80%"}
                    footer={null}
                    centered
                >

                    <Table
                        columns={columns}
                        dataSource={scores}
                        pagination={{
                            defaultPageSize: 10,
                            total: scores.length,
                            pageSizeOptions: ["10", "20", "40"],
                            showSizeChanger: true,
                            locale: {items_per_page: ""}
                        }}
                        scroll={{x: 'max-content'}}
                        scrollToFirstRowOnChange={true}
                        className="score-card-table"
                        size="small"
                    />

                    {/*<div className="row justify-content-center customer-risk-level-cortingen-2 m-10">*/}
                    {/*    <div><strong>{i18n.t('customerRiskScore')}</strong></div>*/}
                    {/*    <div><strong>{riskLevelTag}</strong></div>*/}
                    {/*</div>*/}

                    {/*<div className="row">*/}
                    {/*    {*/}
                    {/*        <div className="col-sm-6 col-md-4 col-lg-3 score-detail-col" key={"txTotalScores"}>*/}
                    {/*            <div className="score-cube">*/}
                    {/*                <div>{txTotalScores}</div>*/}
                    {/*                <div>{i18n.t('txTotalScores')}</div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    }*/}

                    {/*    {ruleEngineScores.map((scoreItem) => {*/}

                    {/*        const {score, source, sourceParams, type} = scoreItem;*/}
                    {/*        const scoreRuleParamDetails = type === "RE" ? this.getParamDetails(sourceParams, customer) : "";*/}

                    {/*        return <div className="col-sm-6 col-md-4 col-lg-3 score-detail-col" key={source}>*/}
                    {/*            <div className="score-cube">*/}
                    {/*                <div>{score}</div>*/}
                    {/*                <div>{scoreRuleParamDetails}</div>*/}
                    {/*                <div>{source}</div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    })}*/}
                    {/*</div>*/}
                </Modal>
            </>
        )
    }

}

function mapStateToProps(state) {

    return {
        common: state.common,
        user: state.user,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        searchAction: SearchAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ScoreCardModal);